import React from 'react';
import { Car, ChevronRight, Loader2 } from 'lucide-react';

const AdminVehicleBrandList = ({ vehiclesData, expandedBrand, setExpandedBrand, selectedVehicle, onSelect }) => (
  <div className="lg:col-span-1 bg-white rounded-lg shadow-sm overflow-hidden">
    <div className="p-4 border-b bg-gray-50">
      <h2 className="font-semibold text-gray-900">Marques & Modèles</h2>
    </div>
    <div className="max-h-[600px] overflow-y-auto">
      {!vehiclesData ? (
        <div className="p-8 text-center">
          <Loader2 className="w-6 h-6 animate-spin mx-auto text-orange-500" />
          <p className="text-sm text-gray-500 mt-2">Chargement...</p>
        </div>
      ) : (
        Object.entries(vehiclesData.brands).sort().map(([brand, models]) => (
          <div key={brand} className="border-b last:border-b-0">
            <button
              onClick={() => setExpandedBrand(expandedBrand === brand ? null : brand)}
              className="w-full flex items-center justify-between px-4 py-3 hover:bg-gray-50 transition-colors"
              data-testid={`admin-vehicle-brand-row-${brand}`}
            >
              <div className="flex items-center gap-2">
                {vehiclesData.logos?.[brand] ? <img src={vehiclesData.logos[brand]} alt={brand} className="w-6 h-6 object-contain" /> : <Car size={18} className="text-orange-500" />}
                <span className="font-medium text-gray-900">{brand}</span>
                <span className="text-xs bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">{models.length}</span>
              </div>
              <ChevronRight size={18} className={`text-gray-400 transition-transform ${expandedBrand === brand ? 'rotate-90' : ''}`} />
            </button>
            {expandedBrand === brand && (
              <div className="bg-gray-50 border-t">
                {models.map((model) => (
                  <button
                    key={model.model}
                    onClick={() => onSelect(brand, model.model)}
                    data-testid={`admin-vehicle-model-row-${brand}-${model.model}`}
                    className={`w-full flex items-center justify-between px-4 pl-10 py-2 hover:bg-orange-50 transition-colors ${
                      selectedVehicle?.brand === brand && selectedVehicle?.model === model.model ? 'bg-orange-50 border-l-2 border-orange-500' : ''
                    }`}
                  >
                    <span className="text-sm text-gray-700">{model.model}</span>
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-gray-400">{model.years?.length || 0} ans</span>
                      <span className="text-xs text-gray-400">{model.engines_count} mot.</span>
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  </div>
);

export default AdminVehicleBrandList;
